import { cloneElement, isValidElement } from "react";
import classNames from "classnames";
export const Slot = ({ children, ...props }) => {
    if (isValidElement(children)) {
        return cloneElement(children, {
            ...props,
            ...children.props,
            className: classNames(children.props.className, props.className),
        });
    }
    throw new TypeError("Single element is allowed in Slot");
};
//# sourceMappingURL=Slot.js.map